module.exports = __webpack_public_path__ + "static/img/img_banner_text.5dcb61d1.png";